import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import SEO from '../components/seo/SEO';
import { getPageBySlug } from '../services/pages';
import { useToast } from '../hooks/use-toast';
import { BRAND_NAME } from '../lib/brand';

const PageContentPage = () => {
  const { slug } = useParams();
  const { toast } = useToast();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        setLoading(true);
        const data = await getPageBySlug(slug);
        setPage(data);
      } catch (error) {
        console.error('Error fetching page:', error);
        toast({
          title: 'Hata',
          description: 'Sayfa yüklenirken bir hata oluştu.',
          variant: 'destructive',
        });
      } finally {
        setLoading(false);
      }
    };
    if (slug) {
      fetchPage();
    }
  }, [slug, toast]);

  if (loading) {
    return (
      <Layout>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <p className="text-gray-600">Yükleniyor...</p>
        </div>
      </Layout>
    );
  }

  if (!page) {
    return (
      <Layout>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-2xl font-semibold">Sayfa bulunamadı</h1>
        </div>
      </Layout>
    );
  }

  const contentHasHeading = /<h1[\s>]/i.test(page.content || '');

  return (
    <Layout>
      <SEO title={`${BRAND_NAME} | ${page.title}`} description={page.title} />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {!contentHasHeading && <h1 className="text-3xl font-bold mb-6">{page.title}</h1>}
        <div
          className="page-content prose prose-sm sm:prose lg:prose-lg max-w-none"
          dangerouslySetInnerHTML={{ __html: page.content }}
        />
      </div>
    </Layout>
  );
};

export default PageContentPage;
